import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
  cancelLink: {
    color: '#979797',
    cursor: 'pointer',
    fontSize: '1rem',
    letterSpacing: '0',
  },
  dialog: {
    '& .MuiDialog-paperScrollPaper': {
      '@media screen and (max-width: 600px)': {
        width: '100%',
      },
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      boxShadow: '0 5px 14px 0 rgba(0,0,0,0.22)',
      padding: '0.5rem 1rem 1rem 1rem !important',
      width: '25%',
    },
  },
  dialogAction: {
    padding: '0 1.5rem !important',
  },
  divider: {
    border: '1px solid #E8E8E8',
    boxSizing: 'border-box',
    height: '1px',
    margin: '0.6rem 0',
    marginLeft: 'unset !important',
  },
  formLabelClass: {
    color: '#241A2E',
    fontFamily: 'FiraSans-Regular',
    fontSize: '0.75rem',
    lineHeight: '24px',
  },
  headerContainer: {
    color: '#241A2E',
    flex: 'auto',
    fontFamily: 'FiraSans-Regular',
    fontSize: '1.1rem',
    fontWeight: 600,
    lineHeight: '26px',
    textTransform: 'uppercase',
  },
  headerWrapper: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
  },
  submitBtnTxt: {
    color: '#FFFFFF',
    fontFamily: 'FiraSans-Medium',
    fontSize: '0.9375rem',
    fontWeight: '500',
    height: '22px',
    letterSpacing: '1px',
    lineHeight: '22px',
    textAlign: 'center',
  },
});
export default useStyles;
